import classNames from 'classnames';
import {
  BUY_PRODUCT,
  BUY_SECONDHAND_FASHION,
  BUY_SECONDHAND_FASHION2,
  FAQ,
  getRouteLanguages,
  INDEX,
  PRODUCT,
  PRODUCTS,
  SHOPS,
  START_EARNING_EXTRA,
  START_EARNING_EXTRA2,
} from 'config/fe-routes';
import React, { useEffect } from 'react';
import { setBrowserNavigationButtonPressed } from 'store/actions/common.actions';

import { I18nKeyModeButton } from '../I18nKeyModeButton/I18nKeyModeButton';

type Props = {
  children: React.ReactElement;
  folderPath: string;
  browserNavigationButtonPressed?: boolean;
};

const MainContainer = (props: Props) => {
  const { children, folderPath, browserNavigationButtonPressed } = props;
  const routeLanguages = getRouteLanguages();

  useEffect(() => {
    setBrowserNavigationButtonPressed(browserNavigationButtonPressed);
  }, [browserNavigationButtonPressed]);

  // Allow full-width pages for these paths
  const IGNORE_PAGE_WIDTH_LIMIT = !!routeLanguages.find((_routeLanguageCode) =>
    [
      INDEX().href,
      SHOPS().href,
      PRODUCTS().href,
      PRODUCT('', '').href,
      FAQ().href,
      START_EARNING_EXTRA().href,
      BUY_SECONDHAND_FASHION().href,
      START_EARNING_EXTRA2().href,
      BUY_SECONDHAND_FASHION2().href,
    ].includes(folderPath),
  );

  const IGNORE_PAGE_BOTTOM_SPACING = !!routeLanguages.find((_routeLanguageCode) =>
    [
      BUY_PRODUCT('', '').href, //
    ].includes(folderPath),
  );

  return (
    <div
      id="main-container"
      className={classNames({
        'ignore-page-width-limit': IGNORE_PAGE_WIDTH_LIMIT,
        'ignore-page-bottom-spacing': IGNORE_PAGE_BOTTOM_SPACING,
      })}
    >
      {children}

      <I18nKeyModeButton />
    </div>
  );
};

export default MainContainer;
